import { Fragment, Suspense, useState } from "react"

import { FiltersPanel } from "~/components/ui/Panels/Filters"
import SquareCta from "~/components/ui/SquareCta"
import { useAlgoliaCustomContext } from "~/providers/AlgoliaCustomContext/index.client"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"

function AlgoliaFilterButton() {
  const t = useTranslate()

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { selectedFilters } = useAlgoliaCustomContext()

  const filtersAmount = Object.values(selectedFilters).reduce((acc, facet) => {
    return acc + (Object.values(facet)?.filter(Boolean)?.length || 0)
  }, 0)

  return (
    <Fragment>
      {/*
        isOpen is needed here to force remount of FiltersPanel
        in order to reset the form when the panel is closed
       */}
      {isOpen && <FiltersPanel open={isOpen} onOpenChange={setIsOpen} />}

      <SquareCta
        theme="backgroundBlack"
        size="small"
        onClick={() => {
          setIsOpen(true)
        }}
      >
        <Fragment>
          <span>{t("filter_bar_cta")}</span>
          {filtersAmount > 0 && <span>&nbsp;({filtersAmount})</span>}
        </Fragment>
      </SquareCta>
    </Fragment>
  )
}

function SuspensedAlgoliaFilterButton() {
  const t = useTranslate()

  return (
    <Suspense
      fallback={
        <SquareCta theme="backgroundBlack" size="small">
          <span>{t("filter_bar_cta")}</span>
        </SquareCta>
      }
    >
      <AlgoliaFilterButton />
    </Suspense>
  )
}

export { SuspensedAlgoliaFilterButton as AlgoliaFilterButton }
